import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import {
  getMembersByPrivateProject,
  Member,
} from '@/services/get-members-by-private-project'

import { GET_MEMBERS_QUERY } from './use-get-members'
import { GET_PROJECTS_QUERY } from './use-get-projects'

type Options = UseQueryOptions<
  Member[],
  unknown,
  Member[],
  (string | number | undefined)[]
>

export const GET_MEMBERS_BY_PRIVATE_UNIT_QUERY = [
  GET_PROJECTS_QUERY,
  GET_MEMBERS_QUERY,
]

export const useGetMembersByPrivateProject = (
  unit: { id: number; private: boolean } | null,
  options?: Options,
) => {
  const query = useQuery(
    [...GET_MEMBERS_BY_PRIVATE_UNIT_QUERY, unit?.id],
    ({ signal }) => getMembersByPrivateProject(unit!.id, { signal }),
    {
      cacheTime: 1,
      ...options,
    },
  )

  return query
}
